import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from '@/store/types'
import { signIn } from '@/store/signin'
import { registration } from '@/store/registration'
import { navigation } from '@/store/navigation'
import { today } from '@/store/today'
import { schedule } from '@/store/schedule'
import { patients } from '@/store/patient'
import { profile } from '@/store/profile'
import { admin } from '@/store/admin'
import { consultories } from '@/store/consultories'
import { doctor } from '@/store/doctor'
import { Layouts } from '@/utils/Layouts'
import UserStorage from '@/utils/Storage/UserStorage'
import { UserData } from '@/utils/Storage/Types'
import router from '@/router'
import { auth } from '@/plugins/firebase'
import { notifications } from '@/store/notifications'
import { chat } from './chat'

const userStorage = UserStorage.getInstance()

Vue.use(Vuex)

const bearer: string = userStorage.getTokenId()?.trim()!!
const currentUser: UserData = userStorage.getObject()!!

const store: StoreOptions<RootState> = {
  state: {
    layout: Layouts.LOGIN_LAYOUT,
    signoutOpen: false
  },

  actions: {
    signout({ commit }) {
      auth
        .signOut()
        .then(() => {
          console.log('User logged out')
        })
        .catch(error => {
          console.error('Error logging out user: ' + error)
        })
      userStorage.clear()
      localStorage.clear()
      commit('SHOW_SIGNOUT_DIALOG', false)
      router.replace({ name: 'signin' }).then(() => router.go(0))
    }
  },

  mutations: {
    SET_LAYOUT(state, payload: Layouts) {
      state.layout = payload
    },

    SHOW_SIGNOUT_DIALOG(state: RootState, payload: boolean) {
      state.signoutOpen = payload
    }
  },

  getters: {
    isAuthenticated: () => !!bearer,
    currentUser: () => currentUser
  },

  modules: {
    registration,
    signIn,
    navigation,
    today,
    schedule,
    patients,
    profile,
    admin,
    doctor,
    consultories,
    notifications,
    chat
  }
}

export default new Vuex.Store<RootState>(store)
